import { Link } from 'react-router-dom';
import { GovCard, GovGridItem } from '@gov-design-system-ce/react';
import { MarkdownRender } from '@gov-nx/component/web';
import { useLocale } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import { LayoutGap } from '@gov-nx/ui/web';
import { truncate } from '@gov-nx/utils/common';
import type { SignpostContext } from '../../../../../module/page/src/rozcestnik/context.types';

const TileContent = ({
	service,
}: {
	service: SignpostContext['data'][number];
}) => (
	<LayoutGap gap="s">
		<h3 className="text-headline-s! text-(--text-primary-color)">
			{service.name}
		</h3>
		{service.description && (
			<MarkdownRender className="mt-0!">
				{truncate(service.description, 150)}
			</MarkdownRender>
		)}
	</LayoutGap>
);

export const HomepageServiceTile = ({
	service,
}: {
	service: SignpostContext['data'][number];
}) => {
	const { t } = useLocale(PageCode['rozcestnik']);

	if (!service.action) return null;

	return (
		<GovGridItem
			column="12"
			columnLg="4"
			key={service.id}>
			<article className="h-full">
				<GovCard asChild>
					{service.action.isLink ? (
						<Link to={service.action.to}>
							<TileContent service={service} />
						</Link>
					) : (
						<button
							aria-label={t('wcag.zobrazit-sluzbu') + service.name}
							onClick={service.action.onClick}
							className="text-left">
							<TileContent service={service} />
						</button>
					)}
				</GovCard>
			</article>
		</GovGridItem>
	);
};
